// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* RedesignedErrorPage.scss */
.error-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f4f4f4;
}

.error-content {
  text-align: center;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.error-image {
  max-width: 500px;
  height: auto;
}

.error-text {
  margin-top: 20px;
}
.error-text .error-code {
  font-size: 4rem;
  font-weight: bold;
  color: #ff6347; /* Tomato red */
}
.error-text .error-message {
  font-size: 1.5rem;
  color: #333;
}
.error-text .home-link {
  margin-top: 20px;
  text-decoration: none;
  color: #007bff; /* Blue link color */
  font-weight: bold;
}
.error-text .home-link:hover {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/Defaults/NoPage/Style.scss"],"names":[],"mappings":"AAAA,6BAAA;AAEA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,yCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,YAAA;AAAJ;;AAGA;EACI,gBAAA;AAAJ;AAEI;EACI,eAAA;EACA,iBAAA;EACA,cAAA,EAAA,eAAA;AAAR;AAGI;EACI,iBAAA;EACA,WAAA;AADR;AAII;EACI,gBAAA;EACA,qBAAA;EACA,cAAA,EAAA,oBAAA;EACA,iBAAA;AAFR;AAIQ;EACI,0BAAA;AAFZ","sourcesContent":["/* RedesignedErrorPage.scss */\r\n\r\n.error-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100vh;\r\n    background-color: #f4f4f4;\r\n}\r\n\r\n.error-content {\r\n    text-align: center;\r\n    background-color: #fff;\r\n    border-radius: 10px;\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\r\n    padding: 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n}\r\n\r\n.error-image {\r\n    max-width: 500px;\r\n    height: auto;\r\n}\r\n\r\n.error-text {\r\n    margin-top: 20px;\r\n\r\n    .error-code {\r\n        font-size: 4rem;\r\n        font-weight: bold;\r\n        color: #ff6347; /* Tomato red */\r\n    }\r\n\r\n    .error-message {\r\n        font-size: 1.5rem;\r\n        color: #333;\r\n    }\r\n\r\n    .home-link {\r\n        margin-top: 20px;\r\n        text-decoration: none;\r\n        color: #007bff; /* Blue link color */\r\n        font-weight: bold;\r\n\r\n        &:hover {\r\n            text-decoration: underline;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
